import React from 'react';
import blogInfo from '../../../Information/BlogInfo/BlogInfo';
import BlogCard from '../../Shear/BlogCard/BlogCard';
import FooterC from '../../Shear/FooterC/FooterC';
import MyNavbar from '../../Shear/MyNavbar/MyNavbar';

const Blog = () => {
    return (
        <main className=''>
            <MyNavbar />
            <section className="container ">
                <div className="d-flex flex-column align-items-center my-3">
                    <h1>My <span style={{ color: '#01DF01' }}>Blogs</span> </h1>
                    <div className="underLine"></div>
                </div>
                <div className="row my-5">
                    {
                        blogInfo.map(blog => <BlogCard key={blog.id} blog={blog}></BlogCard>)
                    }
                </div>
            </section>
            <FooterC />
        </main>
    );
};

export default Blog;